import styled from 'styled-components';

export const AutoDownloadWrapper = styled.div`
  height: 100vh;
`;
